import { render, staticRenderFns } from "./deliveriesTakedOrder.vue?vue&type=template&id=70f6b284&"
import script from "./deliveriesTakedOrder.vue?vue&type=script&lang=js&"
export * from "./deliveriesTakedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports